import { create } from 'jss'
import { jssPreset } from '@mui/styles'
import compose from 'jss-plugin-compose'
import extend from 'jss-plugin-extend'

export const customJssPlugins = [
  ...jssPreset().plugins,
  compose(),
  extend(),
]

const customJss = create({
  plugins: customJssPlugins,
})

export default customJss
